<template>
  <div class="card-form">
    <div class="card-list">
      <Card
        :fields="fields"
        :labels="formData"
        :isCardNumberMasked="isCardNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
        @cardType="cardType"
      />
    </div>
    <div class="card-form__inner">
      <vs-alert color="danger" :active="cardNotSupported">
        <span
          >Tarjeta <strong>{{ this.creditCardname }}</strong> no soportada
        </span>
      </vs-alert>
      <vs-alert color="primary" class="mt-2" :active="secondAlert">
        <span>
          Recuerda utilizar una tarjeta emitida en <strong>Guatemala</strong>
        </span>
      </vs-alert>
      <vs-alert
        color="success"
        class="mt-2"
        :active="
          cardNumberNoEmpty && validCardNumber && isValidDiscountWithCard
        "
      >
        <span>
          Descuento aplicado por pago con tarjeta
        </span>
      </vs-alert>

      <div class="card-input">
        <label for="cardNumber" class="card-input__label"
          >Número de tarjeta{{ /*cardForm.cardNumber*/ }}</label
        >
        <input
          type="tel"
          :id="fields.cardNumber"
          @input="changeNumber"
          @focus="focusCardNumber"
          @blur="blurCardNumber"
          class="card-input__input"
          :value="formData.cardNumber"
          :maxlength="cardNumberMaxLength"
          data-card-field
          autocomplete="off"
          :class="{
            'is-error':
              (!validCardNumber && cardNumberNoEmpty) || cardNotSupported,
          }"
        />
        <button
          class="card-input__eye"
          :class="{ '-active': !isCardNumberMasked }"
          title="Show/Hide card number"
          tabindex="-1"
          :disabled="formData.cardNumber === ''"
          @click="toggleMask"
        ></button>
        <span
          class="mt-2"
          style="color: red"
          v-if="!validCardNumber && cardNumberNoEmpty && !cardNotSupported"
        >
          Ingrese numero de tarjeta valido
        </span>
      </div>
      <div class="card-input">
        <label for="cardName" class="card-input__label"
          >Nombre en tarjeta{{ /*formData.cardName*/ }}</label
        >
        <input
          type="text"
          :id="fields.cardName"
          v-letter-only
          @input="changeName"
          class="card-input__input"
          :value="formData.cardName"
          data-card-field
          autocomplete="off"
        />
      </div>
      <div class="card-form__row">
        <div class="card-form__col">
          <div class="card-form__group">
            <label for="cardMonth" class="card-input__label"
              >Fecha de Expiración{{ /*cardForm.expirationDate*/ }}</label
            >
            <select
              class="card-input__input -select"
              :id="fields.cardMonth"
              v-model="formData.cardMonth"
              @change="changeMonth"
              data-card-field
            >
              <option value disabled selected>{{ /*cardForm.month*/ }}</option>
              <option
                v-bind:value="n < 10 ? '0' + n : n"
                v-for="n in 12"
                v-bind:disabled="n < minCardMonth"
                v-bind:key="n"
                >{{ generateMonthValue(n) }}</option
              >
            </select>
            <select
              class="card-input__input -select"
              :id="fields.cardYear"
              v-model="formData.cardYear"
              @change="changeYear"
              data-card-field
            >
              <option value disabled selected>{{ /*cardForm.year*/ }}</option>
              <option
                v-bind:value="$index + minCardYear"
                v-for="(n, $index) in 12"
                v-bind:key="n"
                >{{ $index + minCardYear }}</option
              >
            </select>
          </div>
        </div>
        <div class="card-form__col -cvv">
          <div class="card-input">
            <label for="cardCvv" class="card-input__label"
              >CVV{{ /*cardForm.CVV*/ }}</label
            >
            <input
              type="tel"
              class="card-input__input"
              v-number-only
              :id="fields.cardCvv"
              maxlength="4"
              :value="formData.cardCvv"
              @input="changeCvv"
              data-card-field
              autocomplete="off"
            />
          </div>
        </div>
      </div>

      <div class="card-form__row" v-if="cardTypeVisa && isTotalAmount">
        <div class="card-form__col">
          <div class="card-form__group">
            <label class="card-input__label"
              >Cuotas mensuales{{ /*cardForm.expirationDate*/ }}</label
            >
            <select
              class="card-input__input -select"
              :id="fields.cardDue"
              v-model="formData.cardDue"
              @change="changeDue"
              data-card-field
              style="background-position: 95% center; !important"
            >
              <option value="" selected>Contado</option>
              <option
                v-bind:value="n.value"
                v-for="(n, $index) in cardFees"
                v-bind:key="n.id"
                >{{ n.name }}</option
              >
            </select>
          </div>
        </div>
      </div>

      <!-- <button class="card-form__button" v-on:click="invaildCard">{{ $t('cardForm.submit') }}</button> -->
    </div>
  </div>
</template>

<script>
import Card from "./Card.vue";
import luhn from "luhn";
import axios from "axios";
export default {
  name: "CardForm",
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          cardName: "",
          cardNumber: "",
          cardNumberNotMask: "",
          cardMonth: "",
          cardYear: "",
          cardCvv: "",
          cardDue: "",
        };
      },
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Card,
  },
  data() {
    return {
      cardNotSupported: false,
      secondAlert: false,
      creditCardname: "",
      validCardNumber: false,
      cardNumberNoEmpty: false,
      fields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv",
        cardDue: "v-card-due",
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19,
      cardTypeVisa: false,
      cardFees: [
        {
          id: 1,
          value: "VC03",
          name: "3",
        },
        {
          id: 2,
          value: "VC06",
          name: "6",
        },
        {
          id: 3,
          value: "VC10",
          name: "10",
        },
        {
          id: 4,
          value: "VC12",
          name: "12",
        },
      ],
      cardBinNumber: "",
    };
  },
  computed: {
    isValidDiscountWithCard() {
      return this.$store.getters["isValidDiscountWithCard"];
    },

    minCardMonth() {
      if (this.formData.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
    isTotalAmount() {
      if (this.totalAmount >= 1000) {
        return true;
      } else {
        // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
        this.formData.cardDue = "";
        this.$emit("input-card-due", this.formData.cardDue);
        return false;
      }
    },
  },
  watch: {
    cardYear() {
      if (this.formData.cardMonth < this.minCardMonth) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cardMonth = "";
      }
    },
  },
  mounted() {
    this.maskCardNumber();
  },
  methods: {
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n;
    },
    changeName(e) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardName = e.target.value;
      this.$emit("input-card-name", this.formData.cardName);
    },
    changeNumber(e) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardNumber = e.target.value;
      const value = this.formData.cardNumber.replace(/\D/g, "");
      this.cardNumberNoEmpty = value ? true : false;
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 17;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == "deleteContentBackward") {
        const lastChar = this.formData.cardNumber.substring(
          this.formData.cardNumber.length,
          this.formData.cardNumber.length - 1
        );
        // eslint-disable-next-line eqeqeq
        if (lastChar == " ") {
          // eslint-disable-next-line eqeqeq, vue/no-mutating-props
          this.formData.cardNumber = this.formData.cardNumber.substring(
            0,
            this.formData.cardNumber.length - 1
          );
        }
      }

      this.validCardNumber = luhn.validate(value);

      this.$emit("input-card-number", this.formData.cardNumber);
      this.$emit("input-valid-card-number", this.validCardNumber);
      this.$emit("input-no-supported-card", this.cardNotSupported);

      this.cardBinNumber = value.substring(0, 6);

      if (this.validCardNumber && this.cardBinNumber.length === 6) {
        this.sendRequestToValidateBin();
      }
    },

    async sendRequestToValidateBin() {
      const formData = new FormData();
      formData.append("bin", this.cardBinNumber);

      await this.$store.dispatch("requestPostCardBinNumberValidator", formData);
    },

    changeMonth() {
      this.$emit("input-card-month", this.formData.cardMonth);
    },
    changeYear() {
      this.$emit("input-card-year", this.formData.cardYear);
    },
    changeDue() {
      this.$emit("input-card-due", this.formData.cardDue);
    },
    changeCvv(e) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardCvv = e.target.value;
      this.$emit("input-card-cvv", this.formData.cardCvv);
    },
    invaildCard() {
      const number = this.formData.cardNumberNotMask.replace(/ /g, "");
      let sum = 0;
      for (let i = 0; i < number.length; i++) {
        let intVal = parseInt(number.substr(i, 1));
        if (i % 2 === 0) {
          intVal *= 2;
          if (intVal > 9) {
            intVal = 1 + (intVal % 10);
          }
        }
        sum += intVal;
      }
      if (sum % 10 !== 0) {
        alert(this.cardForm.invalidCardNumber);
      }
    },
    blurCardNumber() {
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      }
    },
    maskCardNumber() {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardNumberNotMask = this.formData.cardNumber;
      this.mainCardNumber = this.formData.cardNumber;
      const arr = this.formData.cardNumber.split("");
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== "") {
          arr[index] = "*";
        }
      });
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardNumber = arr.join("");
    },
    unMaskCardNumber() {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardNumber = this.mainCardNumber;
    },
    focusCardNumber() {
      this.unMaskCardNumber();
    },
    toggleMask() {
      this.isCardNumberMasked = !this.isCardNumberMasked;
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      } else {
        this.unMaskCardNumber();
      }
    },
    cardType(cardType) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cardDue = "";
      this.$emit("input-card-due", this.formData.cardDue);
      this.cardTypeVisa = false;

      if (cardType) {
        setTimeout(() => {
          this.secondAlert = true;
        }, 500);
      }

      if (cardType == "visa" || cardType == "mastercard") {
        this.cardTypeVisa = true;
      } else if (cardType != "") {
        //send alert to user that card type is not supported
        this.creditCardname = cardType;
        setTimeout(() => {
          this.cardNotSupported = true;
        }, 1000);
      } else if (cardType == "") {
        this.creditCardname = "";
        setTimeout(() => {
          this.cardNotSupported = false;
          this.secondAlert = false;
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/paymentStyles.scss";

.is-error {
  border-color: red;
}
</style>
